// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".voiceover-preview--Na6PV{position:relative;width:100%;height:100%;background-color:#fff}.ripple--KolC8{pointer-events:none}.ripple--KolC8 svg [fill^=rgb]{fill:#5645f5}.ripple--KolC8 svg [stroke^=rgb]{stroke:#5645f5}.layer--OTZho{position:absolute;inset:0;width:100%;height:100%;opacity:1;transition:opacity 300ms ease}.hidden--PZ1nO{opacity:0}.playback--dhrO9{position:absolute;bottom:1rem;left:50%;transform:translateX(-50%);width:min(480px,90%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"voiceover-preview": "voiceover-preview--Na6PV",
	"ripple": "ripple--KolC8",
	"layer": "layer--OTZho",
	"hidden": "hidden--PZ1nO",
	"playback": "playback--dhrO9"
};
export default ___CSS_LOADER_EXPORT___;
